import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getAcceptMasterServiceAgreementPath = () => {
  return urlHelper('/auth/accept-master-service-agreement');
};
